import { isLocale, type Locale } from '@/features/locale/supported-languages';

/**
 * Get the correct translated string from a DB translated object
 *
 * e.g. DB column is JSONB with { [locale]: "string" }
 */
export function takeLocaleString(
  locale: string,
  translations: Record<Locale, string> | string | null | undefined,
): string | undefined {
  if (typeof translations === 'string') {
    return translations;
  }
  if (translations === null || translations === undefined) {
    return undefined;
  }
  // We use || below as opposed to ?? to not return empty strings.
  if (!isLocale(locale)) {
    return translations.en || Object.values(translations)[0] || undefined;
  }
  return (
    translations[locale] ||
    translations.en ||
    Object.values(translations)[0] ||
    undefined
  );
}
